import axios from "axios";
const BASE_HATTRICK_URL = import.meta.env.VITE_HATTRICK_URL;
const BALLPARK_BACKEND_BASE_URL = import.meta.env.VITE_BALLPARK_API_URL;

export async function getProductMetadata(user, axiosOptions, page, size, order, search, filter) {
    console.log("getProductMetadata called");
    let headers = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + user.stsTokenManager.accessToken,
    };
  
    return axios.get(BASE_HATTRICK_URL + `products/productMetadata?page=${page}&size=${size}&order=${btoa(JSON.stringify(order))}&search=${btoa(search ? search : "")}&filter=${btoa(JSON.stringify(filter))}`,
      { ...axiosOptions, headers })
}

